import "../App.css";
import React from "react";
import Helmet from "react-helmet";
 


 

const Questions = (props) => {
    return (

        Object.keys(props.questions).sort((a, b) => a.replace(/\D/g,'') - b.replace(/\D/g,'')).map((key, index) => {
            return (
           

<div className="question"  key={index}>
<h2 onClick={(event)=>{event.target.classList.toggle('open')}}> 


<svg version="1.1"   x="0px" y="0px" viewBox="0 0 94.3 94.3"    >
 
<rect y="39.2" class="st0" width="94.3" height="16"/>
<rect x="0" y="39.2" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 94.3333 -9.023893e-13)" class="st0" width="94.3" height="16"/>
</svg>


    
            <span>{key.substring(key.indexOf("-")+1,key.length)}</span> </h2>
<p  dangerouslySetInnerHTML={{ __html:props.questions[key]}}>
 </p>
</div>
            );
          })
        )
      };

class GettingStarted extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: 0
    };
  }

  

  componentDidMount() {

 

  }

  handleFilter1(event) {
    this.setState({
      filter1: event.target.value,
    });
  }

  handleFilter2(event) {
    this.setState({
      filter2: event.target.value,
    });
  }

  render() {
    return (
      <>
      <Helmet>
        <link rel="canonical" href="https://projectares.academy/faq" />
      </Helmet>
      <div className="faq-hero-wrapper">
      <h1>Frequently Asked Questions</h1>
      <div className="tabs-wrapper">

      {Object.keys(this.props.faqs).map((key, index) => {
            return (
           

<div className={this.state.active==index?"active tab":"tab"}  onClick={()=>{this.setState({active:index})}} key={index}>
<h2>{key}</h2>
<div className="img"></div>
 
</div>
            );
          })}




      </div>
      </div>
      <div className="faq-content-wrapper">

      {Object.keys(this.props.faqs).map((key, index) => {
            return (
           
<div className="faqs-wrapper-wrapper">
<div className={this.state.active==index?"active faqs-wrapper":"faqs-wrapper"}  key={index}>
<h2>{key}</h2>
<Questions questions={this.props.faqs[key]}/>
</div></div>
            );
          })}



      </div>
    
      </>
    );
  }
}

export default GettingStarted;
